<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>delete</v-icon>Rechazar programación </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <h4>
                  <strong>Nombre:</strong> {{ this.form.servidor_publico }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <h4><strong>Detalle papeleta</strong></h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_programaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cancelar
          </v-btn>

          <v-btn color="error" @click.prevent="rechazarProgramacion()"
            ><v-icon>delete</v-icon>
            Rechazar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,

      form: {},
      //url: 'vCronoVacass',
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      gestion: "",
      persona: null,
      saldo: null,
      periodo: null,
      id_estado_programacion: null,
      id: null,
      lista_programaciones: [],
      lista_detalle: [],
      headers: [
        { text: "Fecha salida", sortable: false, align: "center" },
        { text: "Fecha fin", sortable: false, align: "center" },

        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      headers2: [
        { text: "Fecha registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" },
      ],
      // Variables para enviar correos
      datos_usuario: null,
    };
  },
  mounted() {
    this.$bus.$on("openDialogRechazarProgramacionRRHH", async (item) => {
      this.form = item;
      // Obtnemos el correo del servidor seleccionado
      this.datos_usuario = await this.obtieneDatosPersona(this.form.id_persona);
      await this.cargarDetalleProgramacion();
      await this.verEstadoVacacion();
      this.dialog = true;
    });
  },

  methods: {
    // Metodo para obtener los datos de un funcionario
    async obtieneDatosPersona(id_persona) {
      try {
        let usuario = null;
        let respuesta = await this.$service.graphql({
          query: `
          query{
              runQuery(consulta:"select u.correo,u.nombre_usuario,up.id_persona,u.id as id_usuario,p.ap_paterno,p.ap_materno,p.nombres from seguridad.usuario_persona up join seguridad.usuario u  on up.id_usuario =u.id join persona.persona p on up.id_persona =p.id  where up.id_persona =  ${id_persona}"){
                respuesta
              }
            }
          `,
        });
        respuesta = respuesta.runQuery.respuesta;
        if (respuesta.length > 0) {
          usuario = respuesta[0];
        }
        return usuario;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.lista_programaciones = [];
      this.loading = false;
      this.valid = false;

      this.$bus.$emit("closeDialogFinalizarProgramacionRRHH");
      this.dialog = false;
    },
    // Metodo para cargar el detalle de las programaciones
    async cargarDetalleProgramacion() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
            vVacaProgramadas(id_persona:${parseInt(
              this.form.id_persona
            )},gestion:"${this.$util.decodeString(this.$route.params.gestion)}"){
              rows{
              id
              fecha_desde
              fecha_hasta
              id_estado
              fecha_solicitud
              id_persona
              total_dias
              estado
              }
            }
            }
          `,
        });
        this.lista_programaciones = res.vVacaProgramadas.rows;
      } catch (error) {
        console.log(error);
      }
    },

    async verEstadoVacacion() {
      let user = this.$storage.get("user");

      try {
        let res = await this.$service.graphql({
          query: `
			    query{
              vEstadoVacacions(id_persona: ${
                this.form.id_persona
              },gestion_hasta:"${this.$util.decodeString(
            this.$route.params.gestion
          )}"){
                rows{
                  nombre
                  dias_saldo
                  dias_asignados
                  dias_utilizados
                  dias_programados
                  dias_cta_vacacion
                  id
                  id_estado
                  id_persona
                  nombre
                  ingreso
                  gestion_desde
                  gestion_hasta
                  cas
                  estado
                  dias_a_programar
                  total_dias_saldo
                  saldo_a_programar
                  id_programacion
                  id_estado_programacion
                  estado_programacion
                }
              }
            }
					`,
        });
        let estado_vacacion = res.vEstadoVacacions.rows;
        this.id_estado_programacion = parseInt(estado_vacacion[0].id);
      } catch (error) {
        console.log(error);
      }
    },
    async rechazarProgramacion() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");
      this.form.motivo = "0 motivo";
      this.loading = true;
      try {
        respuesta = await this.$service.graphql({
          query: `
           query{
              runQuery(consulta:"select vacaciones.fn_rechaza_programacion_inmediato_superior(${this.id_estado_programacion},${user.id})"){
                respuesta
              }
            }
          `,
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_rechaza_programacion_inmediato_superior;
        resps = respuesta.split("|");
        correcto = resps[0];
        if (correcto === "1") {
          this.$alert("La solicitud fué rechazada", async () => {
            this.loading = false;
            // Metodo para enviar el correo
            if (this.datos_usuario) {
              var mensaje = `
              <h1>NOTIFICACIÓN - RECHAZO DE PROGRAMACIÓN DE VACACIONES</h1>
              Estimado(a): ${this.datos_usuario.nombres} ${this.datos_usuario.ap_paterno} ${this.datos_usuario.ap_materno}<br>
              El motivo de la presente es para informarle que su programación de vacaciones ha sido rechazada. Favor comuniquese con su jefe inmediato superior para coordinar su programación.
              Saludos cordiales. `;
              await this.$service.sendEmail({
                correo: this.datos_usuario.correo,
                asunto: `NOTIFICACIÓN - RECHAZO DE PROGRAMACIÓN DE VACACIONES`,
                mensaje: mensaje.replace(/<[^>]+>/g, ""),
                html: mensaje,
              });
            } else {
              this.$message.info(
                "No se notifico por correo ya que el servidor no posee un correo registrado"
              );
            }
            this.close();
          });
        } else {
          this.$alert(resps[1], () => {
            this.loading = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/RechazarProgramacionRRHH.vue